import { render, staticRenderFns } from "./character_row.vue?vue&type=template&id=5b0b29c6&lang=pug"
import script from "./character_row.vue?vue&type=script&lang=js"
export * from "./character_row.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports